import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=3b5563d2&scoped=true"
import script from "./audit.vue?vue&type=script&lang=js"
export * from "./audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5563d2",
  null
  
)

export default component.exports